// extracted by mini-css-extract-plugin
export var collapsedSummary = "_me-0";